/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import type { Operation } from '@apollo/client';
import { type ErrorHandler } from '@apollo/client/link/error';
import { isUndefined } from 'es-toolkit';

const formatDocumentString = (input: string): string => {
  const trimmedInput = input.trim();
  const lines = trimmedInput.split('\\n');
  let indentLevel = 0;

  const formattedLines = lines.map((line) => {
    if (line.trim() === '') {
      return '';
    }

    let indent = '  '.repeat(indentLevel);

    if (line.includes('{')) {
      indentLevel += 1;
    } else if (line.includes('}')) {
      indentLevel -= 1;
      indent = '  '.repeat(indentLevel);
    }

    return indent + line.trim();
  });

  return formattedLines.join('\n');
};

export const getOperationDetails = (operation: Operation) => ({
  operationName: operation.operationName,
  query: isUndefined(operation.query.loc?.source.body)
    ? undefined
    : formatDocumentString(operation.query.loc?.source.body),
  variables: JSON.stringify(operation.variables),
});

export const getGraphQLErrorsList = (
  graphQLErrors: Parameters<ErrorHandler>[0]['graphQLErrors']
) => {
  if (!graphQLErrors) return;

  const gqlErrors = [];

  for (const { message, path } of graphQLErrors) {
    gqlErrors.push({
      message,
      path: JSON.stringify(path),
    });
  }

  return gqlErrors;
};
